import React from "react";

import { Banner } from "../../../components";

const HomeBanner = () => (

  <Banner
    variant="dual"
    subHeading="Ensuring Your Safety"
    mainHeading="Join Us in Securing Your Property"
    cta={{ text: "Get a Quote", link: "./Get-Quote" }}
    contactInfo={{
      phone: "111-222-333",
      email: "support@example.com",
      ctaText: "Contact Us",
      ctaLink: "./Contact-us"
    }}
  />

);

export default HomeBanner;